import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import {
  AreaChart, Area,
  BarChart, Bar,
  PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import AdminLayout from '../templates/AdminLayout';
import PageHeader from '../molecules/PageHeader';
import StatCard from '../molecules/StatCard';
import { IconList, IconBurger, IconDollarSign } from '../atoms/Icon';

const stats = [
  { label: 'Itens no cardápio', value: 24,         icon: <IconList size={18} /> },
  { label: 'Pedidos hoje',      value: 138,         icon: <IconBurger size={18} /> },
  { label: 'Receita do dia',    value: 'R$ 2.840',  icon: <IconDollarSign size={18} /> },
];

const revenueData = [
  { dia: 'Seg', receita: 1840 },
  { dia: 'Ter', receita: 2200 },
  { dia: 'Qua', receita: 1950 },
  { dia: 'Qui', receita: 2780 },
  { dia: 'Sex', receita: 3400 },
  { dia: 'Sáb', receita: 4100 },
  { dia: 'Dom', receita: 2840 },
];

const ordersData = [
  { dia: 'Seg', pedidos: 92  },
  { dia: 'Ter', pedidos: 118 },
  { dia: 'Qua', pedidos: 104 },
  { dia: 'Qui', pedidos: 143 },
  { dia: 'Sex', pedidos: 178 },
  { dia: 'Sáb', pedidos: 210 },
  { dia: 'Dom', pedidos: 138 },
];

const categoryData = [
  { name: 'Lanches',        value: 48 },
  { name: 'Bebidas',        value: 22 },
  { name: 'Acompanhamentos', value: 18 },
  { name: 'Sobremesas',     value: 12 },
];

const PIE_COLORS = ['#534AB7', '#7F77DD', '#EF9F27', '#FAC775'];

const chartCard = {
  border: 'none',
  borderRadius: 12,
};

const tooltipStyle = {
  borderRadius: 8,
  border: 'none',
  boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
  fontSize: 13,
};

function ChartCard({ title, children }) {
  return (
    <Card style={chartCard} className="h-100 card-elevated">
      <Card.Body className="p-4">
        <div className="fw-semibold mb-3" style={{ fontSize: 14, color: '#444' }}>{title}</div>
        {children}
      </Card.Body>
    </Card>
  );
}

function DashboardPage() {
  return (
    <AdminLayout>
      {/* O selo aqui não fala de prazo, e sim de veracidade: os números e
          gráficos abaixo são fixos no código, e alguém poderia lê-los como o
          movimento real do estabelecimento. */}
      <PageHeader title="Visão geral" badge="Dados de exemplo" />

      {/* Stat cards */}
      <Row className="g-3 mb-4">
        {stats.map((stat) => (
          <Col key={stat.label} xs={12} sm={6} lg={4}>
            <StatCard {...stat} />
          </Col>
        ))}
      </Row>

      {/* Charts row 1 */}
      <Row className="g-3 mb-3">
        <Col xs={12} lg={8}>
          <ChartCard title="Receita dos últimos 7 dias">
            <ResponsiveContainer width="100%" height={220}>
              <AreaChart data={revenueData} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
                <defs>
                  <linearGradient id="gradReceita" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%"  stopColor="#534AB7" stopOpacity={0.2} />
                    <stop offset="95%" stopColor="#534AB7" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="dia" tick={{ fontSize: 12, fill: '#999' }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fontSize: 12, fill: '#999' }} axisLine={false} tickLine={false} tickFormatter={(v) => `R$${v}`} />
                <Tooltip
                  contentStyle={tooltipStyle}
                  formatter={(v) => [`R$ ${v.toLocaleString('pt-BR')}`, 'Receita']}
                />
                <Area
                  type="monotone"
                  dataKey="receita"
                  stroke="#534AB7"
                  strokeWidth={2.5}
                  fill="url(#gradReceita)"
                  dot={{ r: 4, fill: '#534AB7', strokeWidth: 0 }}
                  activeDot={{ r: 6 }}
                />
              </AreaChart>
            </ResponsiveContainer>
          </ChartCard>
        </Col>

        <Col xs={12} lg={4}>
          <ChartCard title="Pedidos por categoria">
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie
                  data={categoryData}
                  cx="50%"
                  cy="50%"
                  innerRadius={55}
                  outerRadius={85}
                  paddingAngle={3}
                  dataKey="value"
                >
                  {categoryData.map((_, i) => (
                    <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip contentStyle={tooltipStyle} formatter={(v) => [`${v}%`, 'Participação']} />
                <Legend iconType="circle" iconSize={8} wrapperStyle={{ fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          </ChartCard>
        </Col>
      </Row>

      {/* Charts row 2 */}
      <Row className="g-3">
        <Col xs={12}>
          <ChartCard title="Pedidos por dia (últimos 7 dias)">
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={ordersData} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
                <XAxis dataKey="dia" tick={{ fontSize: 12, fill: '#999' }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fontSize: 12, fill: '#999' }} axisLine={false} tickLine={false} />
                <Tooltip contentStyle={tooltipStyle} formatter={(v) => [v, 'Pedidos']} />
                <Bar dataKey="pedidos" fill="#EF9F27" radius={[6, 6, 0, 0]} maxBarSize={36} />
              </BarChart>
            </ResponsiveContainer>
          </ChartCard>
        </Col>
      </Row>
    </AdminLayout>
  );
}

export default DashboardPage;
